import * as angular from 'angular';

"use strict";

angular.module('BlocworxModule')
       .controller('AuthenticationController', AuthenticationController);

AuthenticationController.$inject = ['$scope','ScopeAndLocal'];

// Controller Constructor
function AuthenticationController($scope, ScopeAndLocal) {

    // Creating the view model reference
    let vm = this;

    /**
     * Constructor class.
     */
    vm.$onInit = function () {
        try {
            ScopeAndLocal.startVariable(vm, $scope, 'scanStation');
            ScopeAndLocal.startVariable(vm, $scope, 'data');
            ScopeAndLocal.startVariable(vm, $scope, 'main');

        } catch (e) {
            console.log(e);
        }
    }

}

export default AuthenticationController;
